import { render, staticRenderFns } from "./CaracteristicasProduto.vue?vue&type=template&id=0c78c668&scoped=true&"
import script from "./CaracteristicasProduto.vue?vue&type=script&lang=js&"
export * from "./CaracteristicasProduto.vue?vue&type=script&lang=js&"
import style0 from "./CaracteristicasProduto.vue?vue&type=style&index=0&id=0c78c668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c78c668",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c78c668')) {
      api.createRecord('0c78c668', component.options)
    } else {
      api.reload('0c78c668', component.options)
    }
    module.hot.accept("./CaracteristicasProduto.vue?vue&type=template&id=0c78c668&scoped=true&", function () {
      api.rerender('0c78c668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Carteira/InternalTemplates/CaracteristicasProduto.vue"
export default component.exports